export default "__VITE_ASSET__DDNwBe0w__"